<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      :checkbox-config="{ highlight: true, reserve: true }"
      row-id="orderCode"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
      @cell-click="onCellClick"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.orderStatus === 12 || row.orderStatus === 13
              ? 'success'
              : row.orderStatus === 11
              ? 'warning'
              : row.orderStatus === 10
              ? 'primary'
              : 'danger'
          "
        >
          {{ row.v_orderStatus }}
        </el-tag>
      </template>
      <template v-slot:shippingOrderStatus="{ row }">
        <el-tag
          size="mini"
          :type="
            row.shippingOrderStatus === 'D'
              ? 'success'
              : row.shippingOrderStatus === 'Y'
              ? 'warning'
              : 'danger'
          "
        >
          {{ row.v_shippingOrderStatus }}
        </el-tag>
      </template>
      <template v-slot:contact="{ row }">
        <span>
          {{ row.contact || '' }}
        </span>
        <br />
        <span>
          {{ row.phone || '' }}
        </span>
      </template>
      <template v-slot:address="{ row }">
        <span>
          {{ row.country || '' }} {{ row.province || '' }} {{ row.city || '' }}
          {{ row.district || '' }}
        </span>
        <br />
        <div v-if="row.postalCode">
          <span>
            {{ row.postalCode || '' }}
          </span>
        </div>
        <div v-if="row.address1">
          <span>
            {{ row.address1 || '' }}
          </span>
        </div>
        <div v-if="row.address2">
          <span>
            {{ row.address2 || '' }}
          </span>
        </div>
        <div v-if="row.address3">
          <span>
            {{ row.address3 || '' }}
          </span>
        </div>
      </template>
      <template v-slot:shippingMethod="{ row }">
        <span>
          {{ row.carrierName || '' }}
        </span>
        <br />
        <span> TN：{{ row.trackingNo || '' }} </span>
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
                v-show="opt.show == undefined ? true : opt.show(row)"
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
    <chooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="{ templateGroup: 'ecom-order' }"
      :exportOptions="{
        params: {
          searchForm: chooseTemplateOptions.searchForm,
        },
      }"
    />
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import chooseTemplate from '@/views/ecom/components/choose-template'
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
import tableOpts from './table-opts'
export default {
  mixins: [TableAutoHeight, EditLoading],
  components: { chooseTemplate },
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      chooseTemplateOptions: {
        visible: false,
        searchForm: {},
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },
  methods: {
    optCommand({ opt, data }) {
      const { menuType } = opt
      const { orderCode } = data
      switch (menuType) {
        case 'detail':
          this.$emit('openEditPage', {
            orderCode,
          })
          break
        case 'export':
          this.export(data)
          break
        case 'sendEmail':
          this.sendEmail(data)
          break
        case 'confirm':
          this.confirm(data)
          break
        case 'uploadFile':
          this.$emit('openUploadFile', {
            orderCode,
          })
          break
      }
    },
    export({ orderCode }) {
      this.chooseTemplateOptions.visible = true
      this.chooseTemplateOptions.searchForm.orderCode = orderCode
    },

    removeCheckboxRow() {
      this.$refs.table.clearCheckboxRow()
      this.$refs.table.clearCheckboxReserve()
      this.$emit('checkboxChange', [])
    },
    sendEmail(data) {
      const checkList = [data.orderCode]
      this.$emit('sendEmail', { checkList })
    },
    confirm(data) {
      const checkList = [data.orderCode]
      this.$emit('confirm', { checkList })
    },

    // 避免点击操作列也会选择行
    onCellClick({ row, column }) {
      const { property } = column
      const filterColumns = ['checkbox', 'col-opt']
      if (filterColumns.includes(property)) return

      const $table = this.$refs.table
      $table.toggleCheckboxRow(row)
      const data = $table.getCheckboxRecords(true)
      this.$emit(
        'checkboxChange',
        data.concat($table.getCheckboxReserveRecords())
      )
    },
    checkboxChange({ records, reserves }) {
      this.$emit('checkboxChange', records.concat(reserves))
    },
  },
}
</script>
